import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-loader" }

import { Loader } from '@progress/kendo-vue-indicators';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoaderApp',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Loader), {
      size: 'large',
      type: 'pulsing'
    })
  ]))
}
}

})